<ng-template [ngxPermissionsOnly]="['forms:can_get_forms_reports_contacts_submissions']">
  <div class="box-row panel panel-default">
    <div class="panel-body text-center text-alpha">
      <div *ngIf="!isCountLoaded" class="whirl standard spinnermargin"></div>
      <ng-template [ngIf]="isCountLoaded">
        <div class="text-lg mo">{{formSubmissionCount}}</div>
        <p>Form Submission</p>
        <div class="mb-lg"></div>
      </ng-template>
    </div>
  </div>
</ng-template>